module.exports = __webpack_public_path__ + "static/media/john-towner.7f9d96cd.jpg";